import { format, parseISO } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

const formatDateToPtBR = (date: string): string => {
	const formattedDate = format(parseISO(date), "PPP", { locale: ptBR });
	return formattedDate;
};

const formatToDayMonthYear = (date: string): string => {
	const formattedDate = format(parseISO(date), "P", { locale: ptBR });
	return formattedDate;
};

export { formatDateToPtBR, formatToDayMonthYear };
